import Api from './Api'

class User extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'users'
  }

  getUserDetailsByToken(token) {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.path}/retrieve_by_token/${token}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          this.handleError(e)
          reject(e)
        })
    });
  }

  invite(user, locale = 'de') {
    user.locale = locale
    return new Promise((resolve, reject) => {
      this.http.post(this.path + '/invite', user)
        .then(response => {
          resolve(response.data.resource)
        })
        .catch(e => {
          this.handleError(e)
          reject(e)
        })
    });
  }

  inviteXls(formData, locale = 'de'){
    formData.locale = locale
    return new Promise((resolve, reject) => {
      this.http.post(this.path + '/import_xls', formData)
        .then(response => {
          resolve(response)
        })
        .catch((e)=> {
          this.handleError(e)
          reject(e)
        })
    });
  }
}

export default User



// WEBPACK FOOTER //
// ./src/api/User.js